module.exports = __webpack_public_path__ + "img/events.f9647300.svg";